import {Component, Input, OnInit} from '@angular/core';
import { MaterialModule } from 'src/app/app.materials';
import { DecimalPipe } from '@angular/common';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-performance-summary-card',
  templateUrl: './performance-summary-card.component.html',
  styleUrls: ['./performance-summary-card.component.scss'],
  standalone: true,
  imports: [MaterialModule, DecimalPipe, CommonModule]
})
export class PerformanceSummaryCardComponent implements OnInit {

  @Input() summaryRaw: any;
  summaryData: any[] = null;

  constructor() { }

  ngOnInit(): void {
    this.initSummary()
  }

  initSummary() {
    if (this.summaryRaw) {
      this.summaryData = [];
      Object.entries(this.summaryRaw).map(([label, data]) => {
        this.summaryData.push({
          label: label,
          data: Object.entries(data)
        })
      })
    }
  }

}
